import React from 'react';

const DropdownContainer = (props) => {
  const disabled = props.disabled ? "disabled" : "";
  const open = props.open ? "open" : "";

  return (
    <div className={`dropdown-container ${props.className} ${disabled} ${open}`}>
      {props.children}
    </div>
  );
};

DropdownContainer.propTypes = {
  open: React.PropTypes.bool,
  children: React.PropTypes.any,
  className: React.PropTypes.string,
  disabled: React.PropTypes.bool
};

export default DropdownContainer;



// WEBPACK FOOTER //
// ./src/components/dropdown/dropdown-container.jsx